import classNames from "classnames/bind";
import styles from "./Error.module.css";
import settingImage from "../../assets/images/settings.png"
import { Link, useParams } from "react-router-dom";
import { Button } from "../../components";
import InProcessBuild from "../../components/InProcessBuild";
const cx = classNames.bind(styles)

function ErrorPage() {
    const params = useParams()
    const id = params.id
    return (
       <><InProcessBuild /></>
    )
}

export default ErrorPage;